<template>
  <html>
    <body class=".responsive">
      <header class="align--center pt3">
        <div class="container--lg border--bottom pb3">
          <img class="logo mb3" src="../../static/headline.svg" alt="broker-notes">
          <h2 class="mb2">{{texts.headline}}</h2>
          <span>
            <a :href="iosLink" class="link"><img class="download" src="../../static/ios.png" alt="Download on the App Store"></a>
          </span>
          <span>
            <a :href="androidLink" class="link"><img class="download" src="../../static/googleplay.png" alt="Download on Google Play"></a>
          </span>
        </div>
      </header>

      <main>
        <!-- Feature list -->
        <div class="container pt3 mt2 text--gray align--center">
          <p class="mb3">Thousands of practice problems available</p>
          <div class="grid-row">
            <div class="grid-column span-one-third mb3">
              <img class="illustration--small mb1" src="../../static/large_question_bank.svg" alt="Large question bank">
              <p>large question banks</p>
            </div>
            <div class="grid-column span-one-third mb3">
              <img class="illustration--small mb1" src="../../static/mobile_study_app.svg" alt="Mobile study app">
              <p>mobile study app</p>
            </div>
            <div class="grid-column span-one-third mb3">
              <img class="illustration--small mb1" src="../../static/quiz_and_mock_exam.svg" alt="Quiz and mock exam">
              <p>quiz and mock exams</p>
            </div>
          </div>
        </div>

        <!-- Focus -->
        <div class="container--lg pt1 pb1">
            <div class="grid-row grid-row--center">
                <div class="grid-column mt3 mb2 order-2">
                    <div class="border--bottom pb2 mb2">
                        <h2>Quick Practice</h2>
                        <p>With our mobile app you can take practice problems on the go. Frequent practice enhances your knowledge and get you ready for your date of exam.</p>
                    </div>
                    <p class="italic text--gray mb1">I can use Broker Notes app to take a 10 or 20 question quiz when I am waiting for bus, or taking a break from work&nbsp;.Super convenient!</p>
                    <p class="bold">Hassan, Real Estate student in&nbsp;Chicago, IL</p>
                </div>
                <div class="grid-column span-1"></div>
                <div class="grid-column mt3 mb2 order-1">
                    <img src="../../static/quick_practice.svg" alt="Quick Practice">
                </div>
            </div>

            <div class="grid-row grid-row--center">
              <div class="grid-column mt3 mb2">
                <img src="../../static/effective_question_bank.svg" alt="Effective question bank">
              </div>
              <div class="grid-column span-1"></div>
              <div class="grid-column mt3 mb2">
                <div class="border--bottom pb2 mb2">
                    <h2>Effective Question Bank</h2>
                    <p>Thousands of questions available for both national exams and state exams. We provides feedback and progress tracking to help improve on your weakness</p>
                </div>
                <p class="italic text--gray mb1">I can instantly practice on a topic I am not familiar with. It makes study for the exam kind of fund.</p>
                <p class="bold">Terrall, Real Estate agent in &nbsp;Chicago, IL</p>
              </div>
            </div>
        </div>

        <!-- CTA -->
        <div class="bg--dark-gray align--center pt3 pb3">
          <div class="container pt2 pb2">
            <img class="cta-image mb2" src="../../static/try_quiz_on_web.svg" alt="Try quiz on web">
            <p class="h3 text--white mb1 bold">Try our quiz &nbsp;on web</p>
            <p class="text--white mb3">Are you ready to become a real estate agent?</p>
            <button class="btn btn--secondary"><router-link to="/quiz">Start quiz</router-link></button>
          </div>
        </div>
      </main>

      <!-- Footer -->
      <Foot />
    </body>
  </html>
</template>

<script>
import Foot from './Foot'

export default {
   name: 'home',
   components: { Foot },
   data() {
     return {
       texts: {
         headline: "Study to become a Real Estate Agent.",
       }
     }
   },

  computed: {
    androidLink() {
      return this.$store.state.androidLink
    },

    iosLink() {
      return this.$store.state.iosLink
    }
  }
}
</script>
<style lang="scss" scoped>
   @import '../assets/scss/main.scss'
</style>



// WEBPACK FOOTER //
// src/components/Home.vue